import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'form-group-phone',
  templateUrl: './form-group-phone.component.html',
  styleUrls: ['./form-group-phone.component.css']
})
export class FormGroupPhoneComponent {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() messageRequired: string = '';
  @Input() messagePattern: string = 'El número ingresado no es válido';
  @Input() messageCustomFn: string = '';

  constructor() { }


}